import { joinURL } from 'ufo'
import type { Router } from 'vue-router'

export default defineNuxtPlugin({
  name: 'deployment-chunk-recovery',
  // Register before Nuxt's router (-20), which awaits the initial page import.
  order: -21,
  setup(nuxtApp) {
    const chunkErrors = new Set<unknown>()
    let recovering = false

    const recover = (path?: string) => {
      if (recovering) return
      recovering = true
      // Nuxt's sessionStorage cooldown prevents loops across reloads. Omitting
      // path for the current page uses location.reload(), preserving its query
      // and hash; assigning a URL with the same hash can be a no-op instead.
      reloadNuxtApp({ ...(path ? { path } : {}), persistState: true })
    }

    nuxtApp.hook('app:chunkError', ({ error }) => {
      chunkErrors.add(error)
    })
    nuxtApp.hook('app:error', (error) => {
      // Do not reload for speculative prefetch failures or unrelated errors.
      if (
        nuxtApp.isHydrating &&
        (chunkErrors.has(error) || chunkErrors.has(error.cause))
      ) {
        recover()
      }
    })

    nuxtApp.hook('app:created', () => {
      const router = nuxtApp.$router as Router
      const baseURL = useRuntimeConfig().app.baseURL
      const recoverRoute = (to: { fullPath: string }) => {
        recover(joinURL(baseURL, to.fullPath))
      }
      router.beforeEach(() => {
        chunkErrors.clear()
      })
      router.onError((error, to) => {
        if (chunkErrors.has(error)) recoverRoute(to)
      })
      // Preserve Nuxt's normal manifest-update behavior on the next navigation.
      nuxtApp.hook('app:manifest:update', () => {
        router.beforeResolve(recoverRoute)
      })
    })
  },
})
